// Custom JS
import $ from 'jquery';

import 'slick-carousel';
import productDetail from './nova/product-detail'
import productGrid from './nova/product-list'
import categoryList from './nova/category-list'
import featuredProductSlide from './nova/featured-product-slide'

window.jQuery = $;
window.$ = $;

/*!
	Zoom 1.7.21
	license: MIT
	http://www.jacklmoore.com/zoom
*/
(function ($) {
  var defaults = {
    url: false,
    callback: false,
    target: false,
    duration: 120,
    on: 'mouseover', // other options: grab, click, toggle
    touch: true, // enables a touch fallback
    onZoomIn: false,
    onZoomOut: false,
    magnify: 1
  };

  // Core Zoom Logic, independent of event listeners.
  $.zoom = function(target, source, img, magnify) {
    var targetHeight,
      targetWidth,
      sourceHeight,
      sourceWidth,
      xRatio,
      yRatio,
      offset,
      $target = $(target),
      position = $target.css('position'),
      $source = $(source);

    // The parent element needs positioning so that the zoomed element can be correctly positioned within.
    target.style.position = /(absolute|fixed)/.test(position) ? position : 'relative';
    target.style.overflow = 'hidden';
    img.style.width = img.style.height = '';

    $(img)
    .addClass('zoomImg')
    .css({
      position: 'absolute',
      top: 0,
      left: 0,
      opacity: 0,
      width: img.width * magnify,
      height: img.height * magnify,
      border: 'none',
      maxWidth: 'none',
      maxHeight: 'none'
    })
    .appendTo(target);

    return {
      init: function() {
        targetWidth = $target.outerWidth();
        targetHeight = $target.outerHeight();

        if (source === target) {
          sourceWidth = targetWidth;
          sourceHeight = targetHeight;
        } else {
          sourceWidth = $source.outerWidth();
          sourceHeight = $source.outerHeight();
        }

        xRatio = (img.width - targetWidth) / sourceWidth;
        yRatio = (img.height - targetHeight) / sourceHeight;

        offset = $source.offset();
      },
      move: function (e) {
        var left = (e.pageX - offset.left),
          top = (e.pageY - offset.top);

        top = Math.max(Math.min(top, sourceHeight), 0);
        left = Math.max(Math.min(left, sourceWidth), 0);

        img.style.left = (left * -xRatio) + 'px';
        img.style.top = (top * -yRatio) + 'px';
      }
    };
  };

  $.fn.zoom = function (options) {
    return this.each(function () {
      var
        settings = $.extend({}, defaults, options || {}),
        //target will display the zoomed image
        target = settings.target && $(settings.target)[0] || this,
        //source will provide zoom location info (thumbnail)
        source = this,
        $source = $(source),
        img = document.createElement('img'),
        $img = $(img),
        mousemove = 'mousemove.zoom',
        clicked = false,
        touched = false;

      // If a url wasn't specified, look for an image element.
      if (!settings.url) {
        var srcElement = source.querySelector('img');
        if (srcElement) {
          settings.url = srcElement.getAttribute('data-src') || srcElement.currentSrc || srcElement.src;
        }
        if (!settings.url) {
          return;
        }
      }

      $source.one('zoom.destroy', function(position, overflow){
        $source.off(".zoom");
        target.style.position = position;
        target.style.overflow = overflow;
        img.onload = null;
        $img.remove();
      }.bind(this, target.style.position, target.style.overflow));

      img.onload = function () {
        var zoom = $.zoom(target, source, img, settings.magnify);

        function start(e) {
          zoom.init();
          zoom.move(e);

          // Skip the fade-in for IE8 and lower since it chokes on fading-in
          // and changing position based on mousemovement at the same time.
          $img.stop()
          .fadeTo($.support.opacity ? settings.duration : 0, 1, $.isFunction(settings.onZoomIn) ? settings.onZoomIn.call(img) : false);
        }

        function stop() {
          $img.stop()
          .fadeTo(settings.duration, 0, $.isFunction(settings.onZoomOut) ? settings.onZoomOut.call(img) : false);
        }

        // Mouse events
        if (settings.on === 'grab') {
          $source
          .on('mousedown.zoom',
            function (e) {
              if (e.which === 1) {
                $(document).one('mouseup.zoom',
                  function () {
                    stop();

                    $(document).off(mousemove, zoom.move);
                  }
                );

                start(e);

                $(document).on(mousemove, zoom.move);

                e.preventDefault();
              }
            }
          );
        } else if (settings.on === 'click') {
          $source.on('click.zoom',
            function (e) {
              if (clicked) {
                // bubble the event up to the document to trigger the unbind.
                return;
              } else {
                clicked = true;
                start(e);
                $(document).on(mousemove, zoom.move);
                $(document).one('click.zoom',
                  function () {
                    stop();
                    clicked = false;
                    $(document).off(mousemove, zoom.move);
                  }
                );
                return false;
              }
            }
          );
        } else if (settings.on === 'toggle') {
          $source.on('click.zoom',
            function (e) {
              if (clicked) {
                stop();
              } else {
                start(e);
              }
              clicked = !clicked;
            }
          );
        } else if (settings.on === 'mouseover') {
          zoom.init(); // Preemptively call init because IE7 will fire the mousemove handler before the hover handler.

          $source
          .on('mouseenter.zoom', start)
          .on('mouseleave.zoom', stop)
          .on(mousemove, zoom.move);
        }

        // Touch fallback
        if (settings.touch) {
          $source
          .on('touchstart.zoom', function (e) {
            e.preventDefault();
            if (touched) {
              touched = false;
              stop();
            } else {
              touched = true;
              start( e.originalEvent.touches[0] || e.originalEvent.changedTouches[0] );
            }
          })
          .on('touchmove.zoom', function (e) {
            e.preventDefault();
            zoom.move( e.originalEvent.touches[0] || e.originalEvent.changedTouches[0] );
          })
          .on('touchend.zoom', function (e) {
            e.preventDefault();
            if (touched) {
              touched = false;
              stop();
            }
          });
        }

        if ($.isFunction(settings.callback)) {
          settings.callback.call(img);
        }
      };

      img.setAttribute('role', 'presentation');
      img.alt = '';
      img.src = settings.url;
    });
  };

  $.fn.zoom.defaults = defaults;
}(window.jQuery));


$(document).ready(function(){

  if(document.querySelector('.js-product-detail')) {
    productDetail();
  }

  if(document.querySelector('.js-category-list')) {
    categoryList();
  }

  if(document.querySelector('.js-product-list')) {
    productGrid();
  }

  if(document.querySelector('.js-featured-products-slider')) {
    featuredProductSlide();
  }

  if(document.getElementById("general-enquiry-form")){

    $.ajax({
      url: "/!/DynamicToken/refresh",
      type: 'GET',
      success: function(data){
          $('#general-enquiry-form').find('input[name=_token]').val(data.csrf_token)
      },
      error: function(jqXHR){
        console.log('Error: ' + jqXHR.responseText);
      }
    });

  }

  $("#general-enquiry-form button").click(function(){
    var token = $('#general-enquiry-form').find('input[name=_token]').val();
    var sendto = $('input[name=send_to]').val();
    var name = $('input[name=your_name]').val();
    var email = $('input[name=your_email]').val();
    var enquiry = $('textarea[name=your_enquiry]').val();
    var showroom = $('select[name=closest_showroom]').val();
    $('#general-enquiry-form').find('.submission-fail').hide();
    var validate = true;
    $('.form-group').removeClass('error');
    if(!name) {
      validate = false;
      $('input[name=your_name]').parent().addClass('error');
    }
    if(!email) {
      validate = false;
      $('input[name=your_email]').parent().addClass('error');
    }
    if(!enquiry) {
      validate = false;
      $('textarea[name=your_enquiry]').parent().addClass('error');
    }
    if(!showroom) {
      validate = false;
      $('select[name=closest_showroom]').parent().addClass('error');
    }
    if(validate) {
      var url = $('#general-enquiry-form').attr('action');
      var formData = $('#general-enquiry-form').find("input, select, textarea").serialize();
      $('#general-enquiry-form button').prop('disabled', true);
      $('#general-enquiry-form button').html('SENDING...');
      $.ajax({
        type: 'POST',
        url: url,
        data: formData,
        beforeSend: function( jqXHR ) {
          jqXHR.setRequestHeader( 'X-CSRF-Token', token );
        },
        success: function(responseData, textStatus, jqXHR) {
            //alert("Form Sent!")
            $('#general-enquiry-form').find('.form-wrapper').hide();
            $('#general-enquiry-form').find('.submission-success').show();
            dataLayer.push({'event':'form-submission','conversionValue':'contact-form'});
        },
        error: function(jqXHR, textStatus, errorThrown) {
            console.log(jqXHR.responseText);
            $('#general-enquiry-form').find('.submission-fail').show();
            $('#general-enquiry-form button').prop('disabled', false);
            $('#general-enquiry-form button').html('SEND ENQUIRY');
        }
      });
    }
  });

  if(document.getElementById("product-enquiry-form")){

    $.ajax({
      url: "/!/DynamicToken/refresh",
      type: 'GET',
      success: function(data){
          $('#product-enquiry-form').find('input[name=_token]').val(data.csrf_token)
      },
      error: function(jqXHR){
        console.log('Error: ' + jqXHR.responseText);
      }
    });

  }

  $("#product-enquiry-form button").click(function(){
    var token = $('#product-enquiry-form').find('input[name=_token]').val();
    var sendto = $('input[name=send_to]').val();
    var name = $('input[name=your_name]').val();
    var email = $('input[name=your_email]').val();
    var enquiry = $('textarea[name=your_enquiry]').val();
    var showroom = $('select[name=closest_showroom]').val();
    $('#product-enquiry-form').find('.submission-fail').hide();
    var validate = true;
    $('.form-group').removeClass('error');
    if(!name) {
      validate = false;
      $('input[name=your_name]').parent().addClass('error');
    }
    if(!email) {
      validate = false;
      $('input[name=your_email]').parent().addClass('error');
    }
    if(!enquiry) {
      validate = false;
      $('textarea[name=your_enquiry]').parent().addClass('error');
    }
    if(!showroom) {
      validate = false;
      $('select[name=closest_showroom]').parent().addClass('error');
    }
    if(validate) {
      var producturl = $('#product-enquiry-form').attr('action');
      var productformData = $('#product-enquiry-form').find("input, select, textarea").serialize();
      console.log(producturl);
      console.log(productformData);
      $('#product-enquiry-form button').prop('disabled', true);
      $('#product-enquiry-form button').html('SENDING...');
      $.ajax({
        type: 'POST',
        url: producturl,
        data: productformData,
        beforeSend: function( jqXHR ) {
          jqXHR.setRequestHeader( 'X-CSRF-Token', token );
        },
        success: function(responseData, textStatus, jqXHR) {
            //alert("Form Sent!")
            $('#product-enquiry-form').find('.form-wrapper').hide();
            $('#product-enquiry-form').find('.submission-success').show();
            dataLayer.push({'event':'form-submission','conversionValue':'product-enquiry-form'});
        },
        error: function(jqXHR, textStatus, errorThrown) {
            console.log(jqXHR.responseText);
            $('#product-enquiry-form').find('.submission-fail').show();
            $('#product-enquiry-form button').prop('disabled', false);
            $('#product-enquiry-form button').html('SEND ENQUIRY');
        }
      });
    }
  });

  // nearest showroom form select

  $('#nearestshowroomcontact').on('change', function() {
    var sendtoemail = $(this).find(':selected').data('id');
    if(sendtoemail == undefined){
      $('#sendtocontact').val('');
    } else {
      $('#sendtocontact').val(sendtoemail + '@oakleysplumbing.co.nz');
    }
  });

  $('#nearestshowroomproduct').on('change', function() {
    var sendtoemail = $(this).find(':selected').data('id');
    if(sendtoemail == undefined){
      $('#sendtoproduct').val('');
    } else {
      $('#sendtoproduct').val(sendtoemail + '@oakleysplumbing.co.nz');
    }
  });

  // forgot password form

  $('#forgot-password').hide();

  $('.forgot-password').click(function(){
    $('#login-form').hide();
    $('#forgot-password').show();
  });

  $('.remember-password').click(function(){
    $('#login-form').show();
    $('#forgot-password').hide();
  });

  if(document.getElementById("dropContainer")){

    dropContainer.ondragover = dropContainer.ondragenter = function(e) {
      e.preventDefault();
      $('#dropContainer').addClass('hovered');
    };

    dropContainer.ondragleave = function(e) {
      $('#dropContainer').removeClass('hovered');
    }

    dropContainer.ondrop = function(e) {
      e.preventDefault();
      fileInput.files = e.dataTransfer.files;
      $('#dropContainer').removeClass('hovered');
      $('#uploadfile').click();
    };

  }

  // choose file click
  $('#browse').click(function(e){
    e.preventDefault();
    $('#fileInput').click();
  });

  $('#fileInput').on('change', function() {
    $('#uploadfile').click();
  });

  // select project id (add product to project)
  $('#manualid').on('input', function() {
    var mid = this.value;
    $('#projectid').val(mid);
  });

  // product option skip to gallery
  $('button[data-slide]').click(function(e) {
    e.preventDefault();
    if( ! $(this).hasClass('active') ) {
      var slideno = $(this).data('slide');
      $('.product-gallery').slick('slickGoTo', slideno - 1);
    }
    $('button[data-slide]').removeClass('active');
    $(this).addClass('active');
  });

  // product internal back button
  $('.back-to-results').click(function(e){
    if (document.referrer == "") {
      // go to normal link
    } else {
      e.preventDefault();
      window.history.back();
    }
  });

  // my projects without id redirect

  if (window.location.href.indexOf("my-projects/project") > -1 && window.location.search.indexOf("id=") <= -1 ) {
    window.location.href = "/my-projects";
  }

  // product landing add to project

  $('.mobile-add-to-project').click(function(e){

    var productid = $(this).parent().find('.productid').val();
    var producttitle = $(this).parent().find('.producttitle').val();
    var producturl = $(this).parent().find('.producturl').val();
    var productbrand = $(this).parent().find('.productbrand').val();
    var productimage = $(this).parent().find('.productimage').val();

    $('#productid').val(productid);
    $('#productname').val(producttitle);
    $('#productbrand').val(productbrand);
    $('#producturl').val(producturl);
    $('#productimageurl').val(productimage);


  });




  // product enquiry form

  $('.send-enquiry').click(function(){
    $('.product-enquiry-popup-wrapper').show();
  });

  $('.product-enquiry-popup-wrapper .exit').click(function(){
    $('.product-enquiry-popup-wrapper').hide();
  });

  // add product form

  //$('.add-to-project').click(function(){
    //$('.add-product-popup-wrapper').show();
  //});

  $('.add-product-popup-wrapper .exit').click(function(){
    $('.add-product-popup-wrapper').hide();
  });

  $('.project-image-upload-popup-wrapper .exit').click(function(){
    $('.project-image-upload-popup-wrapper').hide();
  });

  // switch register/login form

  $('.sign-up-now').click(function(){
    $('.my-project-popup-wrapper').hide();
    $('.register-popup-wrapper').show();
  });

  $('.have-account').click(function(){
    $('.register-popup-wrapper').hide();
    $('.my-project-popup-wrapper').show();
  });

  $('.register-popup-wrapper .exit').click(function(){
    $('.register-popup-wrapper').hide();
  });

  // colour alert exit

  $('.colour-alert .exit').click(function(e){
    e.preventDefault();
    $('.colour-alert').hide();
  });

  // product alert exit

  $('.product-delete-alert .exit').click(function(e){
    e.preventDefault();
    $('.product-delete-alert').hide();
  });

  // project alert exit

  $('.project-delete-alert .exit').click(function(e){
    e.preventDefault();
    $('.project-delete-alert').hide();
  });

  // email share alerts exit

  $('.email-success .email-success-exit').click(function(e){
    e.preventDefault();
    $('.email-success').removeClass('active');
  });

  $('.email-error .email-error-exit').click(function(e){
    e.preventDefault();
    $('.email-error').removeClass('active');
  });

  // login form

  $('.top-menu-login').click(function(e){

    // logout user if clicked here

    $.ajax({
      url: "/logout", // logout URL
      type: 'GET',
      success: function(data){
        console.log('Logged temp user out');
      },
      error: function(jqXHR){
        console.log('Error: ' + jqXHR.responseText);
      }
    });


    e.preventDefault();
    $('.my-project-popup-wrapper').show();
  });

  $('.my-project-popup-wrapper .exit').click(function(){
    $('.my-project-popup-wrapper').hide();
    $('#forgot-password').hide();
    $('#login-form').show();
  });

  // create project form
  $('.create-project-button').click(function(e){
    e.preventDefault();
    $('.create-project-popup-wrapper').show();
  });

  $('.create-project-popup-wrapper .exit').click(function(){
    $('.create-project-popup-wrapper').hide();
  });

  // mailchimp step 1 (footer)

  $(document).on('submit','form.newsletter-form',function(){
    var emailaddress = $(this).find('input').val();
    $('#mce-EMAIL').val(emailaddress);
    $('.newsletter-popup-wrapper').show();
    return false;
  });


  // mailchimp step 2 (location)

  $('#newsletterLocation').change(function(){
    var locationVal = $(this).val();

    if( locationVal == 'nelson' ){
      $('#architect').val('93096e1a77'); // 93096e1a77

      if ($('#architect').is(':checked') ) {
        $('#mc-embedded-subscribe-form').attr('action', 'https://oakleysplumbing.us19.list-manage.com/subscribe/post-json?u=771e15c40f8a5a9023c1ca1c4&amp;id=93096e1a77&c=?' );
        $('#form-hidden').attr('name', 'b_771e15c40f8a5a9023c1ca1c4_93096e1a77');
      }

    }

    if( locationVal == 'christchurch' ){
      $('#architect').val('6d3b13d5af'); // 6d3b13d5af

      if ($('#architect').is(':checked') ) {
        $('#mc-embedded-subscribe-form').attr('action', 'https://oakleysplumbing.us19.list-manage.com/subscribe/post-json?u=771e15c40f8a5a9023c1ca1c4&amp;id=6d3b13d5af&c=?' );
        $('#form-hidden').attr('name', 'b_771e15c40f8a5a9023c1ca1c4_6d3b13d5af');
      }

    }

    if( locationVal == 'cromwell' ){
      $('#architect').val('7b07138a9a'); // 7b07138a9a

      if ($('#architect').is(':checked') ) {
        $('#mc-embedded-subscribe-form').attr('action', 'https://oakleysplumbing.us19.list-manage.com/subscribe/post-json?u=771e15c40f8a5a9023c1ca1c4&amp;id=7b07138a9a&c=?' );
        $('#form-hidden').attr('name', 'b_771e15c40f8a5a9023c1ca1c4_7b07138a9a');
      }

    }

    if( locationVal == 'dunedin' ){
      $('#architect').val('0cf0acde9a'); // 0cf0acde9a

      if ($('#architect').is(':checked') ) {
        $('#mc-embedded-subscribe-form').attr('action', 'https://oakleysplumbing.us19.list-manage.com/subscribe/post-json?u=771e15c40f8a5a9023c1ca1c4&amp;id=0cf0acde9a&c=?' );
        $('#form-hidden').attr('name', 'b_771e15c40f8a5a9023c1ca1c4_0cf0acde9a');
      }

    }

    if( locationVal == 'northisland' ){
      $('#mc-embedded-subscribe-form').attr('action', 'https://oakleysplumbing.us19.list-manage.com/subscribe/post-json?u=771e15c40f8a5a9023c1ca1c4&amp;id=14c5c2de3f&c=?' );
      $('#form-hidden').attr('name', 'b_771e15c40f8a5a9023c1ca1c4_14c5c2de3f');
    }

  });

  // mailchimp step 3 (popup)

  $('input:radio[name="list"]').change(function(){

    var locationVal = $('#newsletterLocation').val();

    if( locationVal == 'northisland' ) {
      $('#mc-embedded-subscribe-form').attr('action', 'https://oakleysplumbing.us19.list-manage.com/subscribe/post-json?u=771e15c40f8a5a9023c1ca1c4&amp;id=14c5c2de3f&c=?' );
      $('#form-hidden').attr('name', 'b_771e15c40f8a5a9023c1ca1c4_14c5c2de3f');
    } else {

      if ($(this).is(':checked')) {
        var listid = $(this).val();
        $('#mc-embedded-subscribe-form').attr('action', 'https://oakleysplumbing.us19.list-manage.com/subscribe/post-json?u=771e15c40f8a5a9023c1ca1c4&amp;id=' + listid + '&c=?' );
        $('#form-hidden').attr('name', 'b_771e15c40f8a5a9023c1ca1c4_' + listid);
      }

    }

  });

  $('.newsletter-popup .exit').click(function(){
    $('.newsletter-popup-wrapper').hide();
  });

  // submit form

  var $form = $('#mc-embedded-subscribe-form')
  if ($form.length > 0) {
    $('form input[type="submit"]').bind('click', function (event) {
      if (event) event.preventDefault()
      register($form)
    })
  }

  function register($form) {
    $('#mc-embedded-subscribe').val('SENDING...');
    $.ajax({
      type: $form.attr('method'),
      url: $form.attr('action'),
      data: $form.serialize(),
      cache: false,
      dataType: 'jsonp',
      contentType: 'application/json; charset=utf-8',
      error: function (err) { alert('Could not connect to the registration server. Please try again later.') },
      success: function (data) {
        $('#mc-embedded-subscribe').val('SIGN UP FOR EMAILS')
        if (data.result === 'success') {
          // Success
          console.log(data.msg)
          $('.mc-field-group').hide();
          $('#mc-embedded-subscribe').hide();
          $('#mce-success-response').show();
          $('#mce-success-response').html('Thank you for subscribing!');
          $('#mce-EMAIL').val('');
          dataLayer.push({'event':'form-submission','conversionValue':'newsletter-signup-form'});
        } else {
          // Something went wrong, do something to notify the user.
          console.log(data.msg)
          $('#mce-EMAIL').css('borderColor', '#ff8282')
          $('#mce-error-response').show();
          $('#mce-error-response').html(data.msg);
        }
      }
    })
  };

  // home banner slider

  $('.slider').slick({
    prevArrow: $('.home-slider-prev'),
    nextArrow: $('.home-slider-next'),
  });

  // featured products (mobile only)

  function createSlick(){
  $('.featured-products-slider').not('.slick-initialized').slick({
    arrows: false,
    responsive: [
      {
        breakpoint: 9999,
        settings: "unslick",
      },
      {
        breakpoint: 800,
        settings: {
        slidesToShow: 1,
        slidesToScroll: 1
        }
      }
    ]
  });
  }
  createSlick();
  $(window).on('resize', createSlick);

  // design slider

  $('.design-slider').slick({
    prevArrow: $('.design-slider-prev'),
    nextArrow: $('.design-slider-next'),
    dots: true,
  });

  // adjsut design slider dots right position

  var designarrowsright = $('.design').find('.slider-arrows').css('right');
  $('.design-slider').find('.slick-dots').css('right', designarrowsright);

  $(window).resize(function(){
    var designarrowsright = $('.design').find('.slider-arrows').css('right');
    $('.design-slider').find('.slick-dots').css('right', designarrowsright);
  });

  // trends slider

  $('.trends-slider').slick({
    prevArrow: $('.trends-slider-prev'),
    nextArrow: $('.trends-slider-next'),
    dots: true,
  });

  // projects landing slider

  $('.latest-projects-slider').slick({
    prevArrow: $('.latest-projects-slider-prev'),
    nextArrow: $('.latest-projects-slider-next'),
  });

  // projects internal slider

  $('.project-gallery-slider').slick({
    prevArrow: $('.project-gallery-slider-prev'),
    nextArrow: $('.project-gallery-slider-next'),
    dots: true,
  });

  // news events slider

  $('.news-events-slider').slick({
    prevArrow: $('.news-events-slider-prev'),
    nextArrow: $('.news-events-slider-next'),
  });

  // store locator menu mobile

  if($(window).width() < 1200) {

    $('.simple-dropdown > a').click(function(e){

      if( $(this).hasClass('open') ) {
        e.preventDefault();
        $(this).parent().find('.submenu').hide();
        $(this).removeClass('open');
      } else {
        e.preventDefault();
        $(this).parent().find('.submenu').show();
        $(this).addClass('open');
      }

    });

  }

  // mega menu

  if($(window).width() < 1200) {

    $('.products').click(function(e){
      e.preventDefault();
      $('.top-menu').hide();
      $('.main-menu').hide();
      $('.mega-menu').show();
      $('.mega-menu').toggleClass('open');
      //$(this).toggleClass('active');
      $('#main-1').removeClass('active');
    });

    $('.main-menu-return').click(function(){
      $('.mega-menu').hide();
      $('.mega-menu').removeClass('open');
      $('.top-menu').show();
      $('.main-menu').show();
    });

    $('.product-menu-return').click(function(){
      $('.left').show();
      $('.right').hide();
    });

    $('.top-level a').click(function(){
      var mobilemenuid = $(this).attr('id');
      $('.left').hide();
      $('.right').show();
      $('.menu-section').hide();
      $('#menu-' + mobilemenuid).show();
    });

  } else {

    $('.products').click(function(e){
      e.preventDefault();
      $('.mega-menu').toggleClass('open');
      $(this).toggleClass('active');
    });

    $('.top-level a').click(function(){
      var menuid = $(this).attr('id');
      $('.menu-section').hide();
      $('#menu-' + menuid).show();
      $('.top-level a').removeClass('active');
      $(this).addClass('active');
    });

  }

  $(window).resize(function(){

    if($(window).width() < 1200) {

      $('.products').click(function(e){
        e.preventDefault();
        $('.top-menu').hide();
        $('.main-menu').hide();
        $('.mega-menu').show();
        $('.mega-menu').toggleClass('open');
        //$(this).toggleClass('active');
        $('#menu-item-1').removeClass('active');
      });

      $('.main-menu-return').click(function(){
        $('.mega-menu').hide();
        $('.mega-menu').removeClass('open');
        $('.top-menu').show();
        $('.main-menu').show();
      });

      $('.product-menu-return').click(function(){
        $('.left').show();
        $('.right').hide();
      });

      $('.top-level a').click(function(){
        var mobilemenuid = $(this).attr('id');
        $('.left').hide();
        $('.right').show();
        $('.menu-section').hide();
        $('#menu-' + mobilemenuid).show();
      });

    } else {

      $('.products').click(function(e){
        e.preventDefault();
        $('.mega-menu').toggleClass('open');
        $(this).toggleClass('active');
      });

      $('.top-level a').click(function(){
        var menuid = $(this).attr('id');
        $('.menu-section').hide();
        $('#menu-' + menuid).show();
        $('.top-level a').removeClass('active');
        $(this).addClass('active');
      });

    }

  });

  // mega mobile menu

  $('.mobile-menu').click(function(){
    $('.navigation').toggleClass('open');
    $(this).toggleClass('exit');
  });

  // dropdowns


  // dropdowns

  $('.click-container').click(function(){
    $('.dropdown-content').not($(this).next()).hide();
    $('.click-container').find('img').not($(this).find('img')).removeClass('active');

    $(this).next().toggle();
    $(this).find('img').toggleClass('active');
  });

  if ($('.js-product-list').length === 0) {
    $('.click-container-categories').click(function(){
      $('.dropdown-content-categories').not($(this).next()).hide();
      $('.click-container-categories').find('img').not($(this).find('img')).removeClass('active');

      $(this).next().toggle();
      $(this).find('img').toggleClass('active');
    });

    $('.click-container-filters').click(function(){
      $(this).next().toggle();
      $(this).find('img').toggleClass('active');
    });
  }

  $('.filters-mobile .button').click(function(){
    $('.category-list').toggle();
  });

  $(window).resize(() => {
    if ($(window).width() > 800) {
      $('.category-list').show();
    }
  })

  // contact store selector (from contact page)

  $('.submenu a').click(function(){
    var locationclick = $(this).prop("hash");
    var url = $(this).attr('href');

    if (url.indexOf("contact-us") > -1) {

      if( locationclick != '' && locationclick != null ) {
        $('.dropdown-content').not($(this).next()).hide();
        $('.click-container').find('img').not($(this).find('img')).removeClass('active');
        $(locationclick).find('.click-container').next().toggle();
        $(locationclick).find('.click-container').find('img').toggleClass('active');
        $('html,body').animate({scrollTop:$(locationclick).offset().top}, 500);
      }

    } else if (url.indexOf("about-us") > -1) {

      if( locationclick != '' && locationclick != null ) {
        locationclick = locationclick.substr(1);
        $('.location-container').removeClass('active');
        if ( $('.location-container').hasClass(locationclick) ) {
          $('.location-container.' + locationclick).addClass('active');
        }
        $('#select > span').html(locationclick);
        $('#select').find('li').removeClass('selected');
        $('#select').find('.' + locationclick).parent().addClass('selected');
      }

    }

  });

  // contact store selector (from any other page)

  if (window.location.href.indexOf("contact") > -1) {
    var location = window.location.hash;
    if( location != '' && location != null ) {
      $(location).find('.click-container').next().toggle();
      $(location).find('.click-container').find('img').toggleClass('active');
      $('html,body').animate({scrollTop:$(location).offset().top}, 500);
    }
  }

  if (window.location.href.indexOf("about-us") > -1) {
    var location = window.location.hash;
    if( location != '' && location != null ) {
      location = location.substr(1);
      $('.location-container').removeClass('active');
      if ( $('.location-container').hasClass(location) ) {
        $('.location-container.' + location).addClass('active');
      }
      $('#select > span').html(location);
      $('#select').find('li').removeClass('selected');
      $('#select').find('.' + location).parent().addClass('selected');
    }
  }

  // video play button

  $('.video').parent().click(function () {
    if($(this).children(".video").get(0).paused){
      $(this).children(".video").get(0).play();
      $(this).children(".playpause").fadeOut();
    } else {
      $(this).children(".video").get(0).pause();
      $(this).children(".playpause").fadeIn();
    }
  });

  $('.video').bind("ended", function() {
    $(this).parent().children(".playpause").fadeIn();
    $(this).get(0).currentTime = 0;
  });

  // product internal tabs

  $('.tabs a').click(function(){
    var t = $(this).attr('id');
    $('.tabs a').removeClass('active');
    $(this).addClass('active');
    $('.tab-content').hide();
    $('#'+ t + 'C').show();
    $('#'+ t + 'Cm').show();
  });

  // my project tabs

  $('.show-products').click(function(){
    $('.my-project-menu').find('a').removeClass('active');
    $('.my-project-menu-mobile').find('a').removeClass('active');
    $('.show-products').addClass('active');
    $('#products').show();
    $('#documents').hide();
    $('#colours').hide();
    $('#share').hide();
    //magicGrid.positionItems();
    $("html, body").animate({ scrollTop: 0 }, "slow");
    $('.product-delete-alert').hide();
  });

  $('.show-documents').click(function(){
    $('.my-project-menu').find('a').removeClass('active');
    $('.my-project-menu-mobile').find('a').removeClass('active');
    $('.show-documents').addClass('active');
    $('#products').hide();
    $('#documents').show();
    $('#colours').hide();
    $('#share').hide();
    //magicGrid2.positionItems();
    $("html, body").animate({ scrollTop: 0 }, "slow");return false;
  });

  $('.show-colours').click(function(){
    $('.my-project-menu').find('a').removeClass('active');
    $('.my-project-menu-mobile').find('a').removeClass('active');
    $('.show-colours').addClass('active');
    $('#products').hide();
    $('#documents').hide();
    $('#colours').show();
    $('#share').hide();
    $("html, body").animate({ scrollTop: 0 }, "slow");return false;
  });

  $('.show-share').click(function(){
    $('.my-project-menu').find('a').removeClass('active');
    $('.my-project-menu-mobile').find('a').removeClass('active');
    $('.show-share').addClass('active');
    $('#products').hide();
    $('#documents').hide();
    $('#colours').hide();
    $('#share').show();
    $("html, body").animate({ scrollTop: 0 }, "slow");return false;
  });

  // project category filtering

  $('.project-filters a').click(function(){
    var filterclass = $(this).attr('class');
    if( ! $(this).hasClass('active') ) {
      if( $(this).hasClass('all-projects') ) {
        $('.project-container').find('.item').removeClass('category-hidden');
        $('.project-filters a').removeClass('active');
        $(this).addClass('active');
      } else {
        $('.project-container').find('.item').addClass('category-hidden');
        $('.project-container').find('.' + filterclass).removeClass('category-hidden');
        $('.project-filters a').removeClass('active');
        $(this).addClass('active');
      }
    }
  });

  // project filtering

  $('ul.drop li').click(function(){
    var projectlocation = $(this).find('a').attr('class');
    console.log(projectlocation);
    if(projectlocation == 'all') {
      $('.project-container').find('.item').removeClass('location-hidden');
    } else {
      $('.project-container').find('.item').addClass('location-hidden');
      $('.project-container').find('*[data-location="' + projectlocation + '"]').removeClass('location-hidden');
    }
  });


  // our team filtering

  $('ul.drop li').click(function(){
    var teamlocation = $(this).find('a').attr('class');
    if(teamlocation == 'all') {
      $('.team-container').find('.item').addClass('active');
    } else {
      $('.team-container').find('.item').removeClass('active');
      $('.team-container').find('.' + teamlocation).addClass('active');
    }
  });

  // about us filtering

  $('ul.drop li').click(function(){
    var selectedoption = $(this).find('a').attr('class');
    $('.location-container').removeClass('active');
    if ( $('.location-container').hasClass(selectedoption) ) {
      $('.location-container.' + selectedoption).addClass('active');
    }
  });


});


if (document.querySelector('.product-gallery')) {

  // initialise slick
  setTimeout(() => {
    // product gallery
    initialiseSlickAndZoom();
  }, 1000);

}

export function initialiseSlickAndZoom() {
  $('.product-gallery').not('.slick-initialized').slick({
    prevArrow: $('.product-gallery-prev'),
    nextArrow: $('.product-gallery-next'),
    asNavFor: '.product-sub-gallery',
    infinite: true,
  }).removeClass('is-initialising');

  $('.product-sub-gallery').not('.slick-initialized').slick({
    arrows: false,
    asNavFor: '.product-gallery',
    slidesToShow: '3',
    infinite: true,
  }).removeClass('is-initialising');;

  $('img[data-slide]').click(function(e) {
    let slideIndex = $(this).data('slide');
    $('.product-gallery').slick('slickGoTo', slideIndex -1);
  });

  if (document.querySelector('.image-zoom')) {
    $('.image-zoom')
    .wrap('<span style="display:block;"></span>')
    .css('display', 'block')
    .parent()
    .zoom();
  }
}

export function unSlickAndZoom() {
  $('.product-gallery').addClass('is-initialising');
  $('.product-sub-gallery').addClass('is-initialising');
  return new Promise(function(resolve, reject) {
    setTimeout(() => {
      $('.product-gallery').slick('unslick').children().remove();
      $('.product-sub-gallery').slick('unslick').children().remove();
      resolve();
    }, 300)
  });
}
